import { Player } from "@lottiefiles/react-lottie-player";


const LoaderOverlay = () => (
  <div className="spLoader fixed inset-0 z-50 items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50/30 backdrop-blur-sm">
    <div className="flex flex-col items-center space-y-6">
      <Player
        autoplay
        loop
        src="/loader/loader.json"
        style={{ width: "920px", height: "920px" }}
        className="drop-shadow-xl"
      />
      {/* <div className="text-center space-y-2">
        <p className="text-sm text-slate-500">Preparing your workspace…</p>
      </div> */}
    </div>
  </div>
);

export default LoaderOverlay;
